<template>
  <div>
    <div class="card">
      <div class="card-header animated fadeInRightBig">
        <div class="card-title">
          Solicitação de ausencia
        </div>
      </div>
      <div class="card-body">
        <div class="row mb-3">
          <div class="col-md-6">
            <label> <span class="required">*</span> Data e hora Inicio </label>
            <date-time
              v-model="absenceRequests.start_date"
              format="YYYY-MM-DD HH:mm:ss"
              formatted="DD/MM/YYYY HH:mm:ss"
              output-format="YYYY-MM-DD HH:mm:ss"
              :no-button-now="true"
            >
              <input
                type="text"
                class="form-control"
                :value="absenceRequests.start_date"
              >
            </date-time>
          </div>
          <div class="col-md-6">
            <label> <span class="required">*</span> Data e hora Fim </label>
            <date-time
              v-model="absenceRequests.end_date"
              format="YYYY-MM-DD HH:mm:ss"
              formatted="DD/MM/YYYY HH:mm:ss"
              output-format="YYYY-MM-DD HH:mm:ss"
              :no-button-now="true"
            >
              <input
                type="text"
                class="form-control"
                :value="absenceRequests.end_date"
              >
            </date-time>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-12">
            <label> <span class="required">*</span> Justificativa </label>
            <textarea
              v-model="absenceRequests.justification"
              rows="5"
              class="form-control"
            />
          </div>
        </div>
        <!-- A Necessidade disso sera revisada.
          <div class="col-md-12">
          <br />
          <label>Anexo</label>
          <br />
          <input type="file" id="attachm" />
        </div>-->
        <div class="block text-right">
          <router-link
            to="/absenceRequests"
            class="btn btn-info"
          >
            <i class="fa fa-arrow-left" /> Voltar
          </router-link>
          <a
            class="btn btn-success"
            @click="save"
          >
            Salvar
            <i class="fa fa-save" />
          </a>
        </div>
        <div class="row">
          <div class="col-md-4">
            <p><span class="required">*</span> Campos Obrigatórios</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      users: [],
      absenceRequests: {
        start_date: '',
        end_date: '',
        justification: '',
      },
    }
  },
  mounted() {
    const self = this

    const { id } = self.$route.params
    if (id) {
      self.getAbsenceRequests(id)
    }
  },
  methods: {
    save() {
      const self = this

      if (self.absenceRequests.id) return self.edit()

      const api = `${this.$store.state.api}absencerequests`

      const fd = self.makeFormData()
      if (!fd) return

      axios
        .post(api, fd)
        .then(response => {
          self.$message(
            'Sucesso',
            'Solicitação de marcação cadastrada com sucesso',
            'success',
          )
          this.$router.push('/absenceRequests')
        })
        .catch(error => {
          self.$message(null, error.response.data, 'error')
        })
    },
    makeFormData() {
      const self = this
      const fd = new FormData()

      fd.append('start_date', self.absenceRequests.start_date)
      fd.append('end_date', self.absenceRequests.end_date)
      fd.append('description', self.absenceRequests.justification)
      fd.append('user_id', self.$store.getters.user.id)
      fd.append('status_id', '1')

      if (self.absenceRequests.id) {
        fd.append('id', self.absenceRequests.id)
        fd.append('_method', 'PUT')
      }

      return fd
    },
    getAbsenceRequests(id) {
      const self = this
      const api = `${self.$store.state.api}absencerequests/${id}`

      axios
        .get(api)
        .then(response => {
          self.absenceRequest = response.data.data[0]
        })
        .catch(error => {
          self.errors = error.response.data
          self.$message(null, self.errors, 'error')
        })
    },
  },
}
</script>
